import Vue from 'vue'
import routerPageHook from '@assets/js/routerPageHook.js'
import BannerBtn from '@components/ui-components/banner-btn/component.js'
import Card from '@components/ui-components/card/component.js'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import titleLink from '@components/ui-components/title-link/component.js'
import materialsItem from '@components/ui-components/materials-item/component.js'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      error: false,
    }
  },
  components: {
    'banner-btn-cmp': BannerBtn,
    'card-cmp': Card,
    'page-form-cmp': PageForm,
    'title-link-cmp': titleLink,
    'materials-item-cmp': materialsItem,
  },
  methods: {
    errorData(data) {
      this.error = data.error
    },
    setIcon(type) {
      switch (type.toLowerCase()) {
        case 'png':
        case 'jpg':
        case 'jpeg':
          return (
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M22.3543 5.06055H3.64566C3.28908 5.06055 3 5.34954 3 5.7062V20.2938C3 20.6505 3.28908 20.9395 3.64566 20.9395H22.3543C22.7109 20.9395 23 20.6505 23 20.2938V5.7062C23 5.34963 22.7109 5.06055 22.3543 5.06055ZM21.7087 6.35194V18.6703L16.5439 13.178C16.4219 13.0483 16.2517 12.9746 16.0737 12.9746C16.0736 12.9746 16.0736 12.9746 16.0736 12.9746C15.8955 12.9746 15.7254 13.0483 15.6034 13.1778L13.3978 15.5217L10.4408 11.6227C10.3187 11.4617 10.1284 11.3672 9.92633 11.3672C9.92616 11.3672 9.92599 11.3672 9.92582 11.3672C9.7236 11.3674 9.53317 11.4623 9.41127 11.6236L4.29131 18.3977V6.35194H21.7087ZM20.8558 19.6482H4.96486L9.9272 13.0824L12.8302 16.9103C12.9451 17.0617 13.1207 17.1548 13.3104 17.1649C13.4999 17.1743 13.6847 17.101 13.8149 16.9626L16.0733 14.5625L20.8558 19.6482Z" fill="#C8C8C8"/>\n' +
            '<path d="M16.3648 11.7531C17.5353 11.7531 18.4875 10.8009 18.4875 9.63055C18.4875 8.46002 17.5353 7.50781 16.3648 7.50781C15.1943 7.50781 14.2422 8.46011 14.2422 9.63055C14.2422 10.8009 15.1944 11.7531 16.3648 11.7531ZM16.3648 8.79904C16.8233 8.79904 17.1962 9.17205 17.1962 9.63047C17.1962 10.0888 16.8233 10.4617 16.3648 10.4617C15.9063 10.4617 15.5335 10.0888 15.5335 9.63047C15.5335 9.17205 15.9064 8.79904 16.3648 8.79904Z" fill="#C8C8C8"/>\n' +
            '</svg>'
          )
        case 'eps':
          return (
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M19.8516 2C18.87 2 18.0408 2.66184 17.785 3.5625H14.1094V2H9.8125V3.5625H6.215C5.95922 2.66184 5.12996 2 4.14844 2C2.96379 2 2 2.96379 2 4.14844C2 5.33309 2.96379 6.29688 4.14844 6.29688C5.12996 6.29688 5.95922 5.63504 6.215 4.73438H9.8125V6.29688H11.2071L5.44125 14.9447H6.53613C8.10582 14.9447 9.38281 16.2217 9.38281 17.7914V18.4844H8.03516V22H15.8086V18.4844H14.5391V17.7963C14.5391 16.2239 15.8183 14.9447 17.3906 14.9447H18.4855L12.7197 6.29688H14.1094V4.73438H17.785C18.0407 5.63504 18.87 6.29688 19.8516 6.29688C21.0362 6.29688 22 5.33309 22 4.14844C22 2.96379 21.0362 2 19.8516 2V2ZM4.14844 5.125C3.60996 5.125 3.17188 4.68691 3.17188 4.14844C3.17188 3.60996 3.60996 3.17188 4.14844 3.17188C4.68691 3.17188 5.125 3.60996 5.125 4.14844C5.125 4.68691 4.68691 5.125 4.14844 5.125ZM14.6367 20.8281H9.20703V19.6562H14.6367V20.8281ZM13.3672 17.7963V18.4844H10.5547V17.7914C10.5547 15.9241 9.2743 14.3501 7.54547 13.9012L11.3775 8.15383V13.8618H12.5493V8.15379L16.3812 13.901C14.6497 14.3501 13.3672 15.9263 13.3672 17.7963ZM12.9375 5.125H10.9844V3.17188H12.9375V5.125ZM19.8516 5.125C19.3131 5.125 18.875 4.68691 18.875 4.14844C18.875 3.60996 19.3131 3.17188 19.8516 3.17188C20.39 3.17188 20.8281 3.60996 20.8281 4.14844C20.8281 4.68691 20.39 5.125 19.8516 5.125Z" fill="#C8C8C8"/>\n' +
            '</svg>'
          )
        default:
          return (
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<g clip-path="url(#clip0)">\n' +
            '<path d="M19.633 7.40844L14.4156 2.19105C14.2989 2.07422 14.1337 2 13.9545 2H4.82406C4.46391 2 4.17188 2.29199 4.17188 2.65219V21.3479C4.17188 21.708 4.46387 22 4.82406 22H19.1719C19.532 22 19.8241 21.708 19.8241 21.3479V7.86957C19.8241 7.70391 19.7584 7.53383 19.633 7.40844ZM14.6067 4.22664L16.102 5.72199L17.5974 7.21738H14.6067V4.22664ZM18.5197 20.6957H5.47621V3.30434H13.3023V7.86957C13.3023 8.22973 13.5943 8.52176 13.9545 8.52176H18.5197V20.6957Z" fill="#C8C8C8"/>\n' +
            '<path d="M16.5639 11.5664H7.43344C7.07328 11.5664 6.78125 11.8584 6.78125 12.2186C6.78125 12.5788 7.07324 12.8708 7.43344 12.8708H16.5639C16.9241 12.8708 17.2161 12.5788 17.2161 12.2186C17.2161 11.8584 16.9241 11.5664 16.5639 11.5664Z" fill="#C8C8C8"/>\n' +
            '<path d="M16.5639 14.1738H7.43344C7.07328 14.1738 6.78125 14.4658 6.78125 14.826C6.78125 15.1862 7.07324 15.4782 7.43344 15.4782H16.5639C16.9241 15.4782 17.2161 15.1862 17.2161 14.826C17.2161 14.4658 16.9241 14.1738 16.5639 14.1738Z" fill="#C8C8C8"/>\n' +
            '<path d="M12.6509 16.7812H7.43344C7.07328 16.7812 6.78125 17.0732 6.78125 17.4334C6.78125 17.7936 7.07324 18.0856 7.43344 18.0856H12.6508C13.011 18.0856 13.303 17.7936 13.303 17.4334C13.303 17.0732 13.011 16.7812 12.6509 16.7812Z" fill="#C8C8C8"/>\n' +
            '</g>\n' +
            '<defs>\n' +
            '<clipPath id="clip0">\n' +
            '<rect width="20" height="20" fill="white" transform="translate(2 2)"/>\n' +
            '</clipPath>\n' +
            '</defs>\n' +
            '</svg>'
          )
      }
    },
  },
  ...routerPageHook,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/press-center/index.js